var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1612 4.57904L9.77378 0.191643C9.65145 0.0693176 9.48631 0 9.31302 0H0.6524C0.291541 0 0 0.291541 0 0.6524V17.6148C0 17.9757 0.291541 18.2672 0.6524 18.2672H13.7004C14.0613 18.2672 14.3528 17.9757 14.3528 17.6148V5.04183C14.3528 4.86854 14.2835 4.70136 14.1612 4.57904ZM12.8482 5.34153H9.01128V1.5046L12.8482 5.34153ZM12.8849 16.7993H1.4679V1.4679H7.62493V5.8716C7.62493 6.0987 7.71514 6.3165 7.87573 6.47708C8.03631 6.63767 8.25411 6.72788 8.48121 6.72788H12.8849V16.7993ZM7.01331 11.2947H3.262C3.1723 11.2947 3.0989 11.3681 3.0989 11.4578V12.4364C3.0989 12.5261 3.1723 12.5995 3.262 12.5995H7.01331C7.10301 12.5995 7.17641 12.5261 7.17641 12.4364V11.4578C7.17641 11.3681 7.10301 11.2947 7.01331 11.2947ZM3.0989 8.68508V9.66368C3.0989 9.75339 3.1723 9.82678 3.262 9.82678H11.0908C11.1805 9.82678 11.2539 9.75339 11.2539 9.66368V8.68508C11.2539 8.59538 11.1805 8.52198 11.0908 8.52198H3.262C3.1723 8.52198 3.0989 8.59538 3.0989 8.68508Z",
    fill: "#A0A3B1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.057c8fae022604ffdb32ad48f821a6ba.svg";
export { ForwardRef as ReactComponent };